import type { FieldPath, FieldValues } from 'react-hook-form';

type Success = {
	valid: true;
	issues: undefined;
};

/** Initial validations success results. */
export const validationSuccess: Success = {
	valid: true,
	issues: undefined,
};

type Failure<T extends FieldValues> = {
	valid: false;
	issues: {
		message: string;
		path: FieldPath<T>;
	}[];
};

/** Cummulative validation results structure. */
export type ValidationResults<T extends FieldValues> = Success | Failure<T>;

/** Adds issue to validation results. */
export const addValidationIssue = <T extends FieldValues>(
	results: ValidationResults<T>,
	message: string,
	path: FieldPath<T>,
): ValidationResults<T> => {
	const issue = { message, path };

	if (results.valid) {
		return { valid: false, issues: [issue] };
	}

	if (results.issues.some((issue) => issue.path === path)) {
		return results;
	}

	return {
		...results,
		issues: [...results.issues, issue],
	};
};
